import React from "react";
import PropTypes from "prop-types";
import { Modal, ModalBody } from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
	Button,
	Form,
	FormGroup,
	Row,
	Col,
	Input,
	FormFeedback,
	Label,
} from "reactstrap";
import { FloppyDisk, SignOut } from "@phosphor-icons/react";
import loginImagesService from "services/LoginImagesService";
import { SendaCustomSwal } from "components/Common/SendaCustomSwal";
import UploadUnico from "components/atom/UploadUnico";

const UploadLoginImageModal = ({ show, onCloseClick }) => {
	const validation = useFormik({
		enableReinitialize: true,
		initialValues: {
			image: null,
		},

		validationSchema: Yup.object({
			image: Yup.mixed().required("Por favor, envie uma imagem."),
		}),

		onSubmit: async (values) => {
			console.log("Submissão:", values);
			// if (!values.image) {
			// 	console.error("Nenhuma imagem enviada!");
			// 	return;
			// }
			try {
				const data = { name: values.image };

				console.log(data);

				const response = await loginImagesService.create(data);
				SendaCustomSwal.fire({
					iconHtml: '<i class="success-icon"></i>',
					title: "Sucesso",
					text: response.message,
					customClass: {
						confirmButton: "custom-confirm-button",
					},
				});
				validation.resetForm();
				onCloseClick();
			} catch (error) {
				console.error("Erro inesperado:", error);
			}
		},
	});

	return (
		<>
			<Modal
				size="sm"
				isOpen={show}
				toggle={onCloseClick}
				centered={true}
				style={{ minWidth: 800 }}
			>
				<div className="modal-content">
					<ModalBody className="px-4 py-3 text-center">
						<Col md="12">
							<Form
								className="needs-validation"
								onSubmit={(e) => {
									e.preventDefault();
									validation.handleSubmit();
								}}
							>
								<h4 className="text-center my-4">
									Nova Imagem
								</h4>

								{/* Imagem */}
								<Row>
									<Col md="12">
										<FormGroup className="mb-3">
											<Label htmlFor="image">
												Upload de Imagem{" "}
												<span style={{ color: "red" }}>
													*
												</span>
											</Label>
											<UploadUnico
												key={validation.values.image}
												value={validation.values.image}
												onChange={(file) => {
													console.log(
														"Valor do UploadUnico:",
														file,
													);
													validation.setFieldValue(
														"image",
														file,
													);
												}}
												onBlur={() => {
													console.log(
														"Campo foi tocado.",
													);
													validation.setFieldTouched(
														"image",
														true,
													);
												}}
											/>
											{validation.touched.image &&
											validation.errors.image ? (
												<FormFeedback type="invalid">
													{validation.errors.image}
												</FormFeedback>
											) : null}
										</FormGroup>
									</Col>
								</Row>

								{/* Botões de Submissão e Fechamento */}
								<Row className="py-1">
									<div className="hstack gap-2 justify-content-center mb-0">
										<Button
											type="submit"
											disabled={validation.isSubmitting}
											style={{
												background: "none",
												padding: 10,
												cursor: "pointer",
												color: "black",
												marginLeft: 10,
												width: 150,
												display: "flex",
												alignItems: "center",
												justifyContent: "center",
												gap: 2,
											}}
										>
											{validation.isSubmitting ? (
												<span
													className="spinner-border spinner-border-sm mr-1"
													style={{ marginRight: 10 }}
												></span>
											) : null}
											<FloppyDisk size={16} /> Salvar
										</Button>
										<Button
											type="button"
											onClick={() => {
												validation.setFieldValue(
													"image",
													null,
												);
												validation.setFieldTouched(
													"image",
													false,
												);
												validation.resetForm();
												onCloseClick();
											}}
											style={{
												background: "none",
												padding: 10,
												cursor: "pointer",
												color: "black",
												marginLeft: 10,
												width: 150,
												display: "flex",
												alignItems: "center",
												justifyContent: "center",
												gap: 2,
											}}
										>
											<SignOut size={16} /> Fechar
										</Button>
									</div>
								</Row>
							</Form>
						</Col>
					</ModalBody>
				</div>
			</Modal>
		</>
	);
};

UploadLoginImageModal.propTypes = {
	show: PropTypes.bool,
	onCloseClick: PropTypes.func,
};

export default UploadLoginImageModal;
